import { useTranslation } from 'react-i18next';

import type { InventoryMovementKind } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import { movementDirection } from '../schemas/inventory-rules';

const WARNING = 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25';
const SUCCESS = 'bg-success/15 text-success border-transparent dark:bg-success/20';
const NEUTRAL = 'border-border text-muted-foreground';
const DANGER = 'bg-destructive/10 text-destructive border-transparent';

export function LowStockBadge({ className }: { className?: string }) {
  const { t } = useTranslation('inventory');
  return (
    <Badge variant="outline" className={cn(WARNING, className)}>
      {t('levels.lowStock')}
    </Badge>
  );
}

const DIRECTION = { in: SUCCESS, out: DANGER, reservation: NEUTRAL } as const;

export function MovementKindBadge({
  kind,
  quantity,
  className,
}: {
  kind: InventoryMovementKind;
  quantity: number;
  className?: string;
}) {
  const { t } = useTranslation('inventory');
  return (
    <Badge
      variant="outline"
      className={cn(DIRECTION[movementDirection(kind, quantity)], className)}
    >
      {t(`movements.kind.${kind}`)}
    </Badge>
  );
}
